<div class="toast-wrapper">
  <button class="to-right d-flex align-items-center justify-content-center icon-button other-bg" (click)="remove()">
    <i class="ri-close-line"></i>
  </button>
  <div class="d-flex m-r-4 align-items-start">
    <div class="icon">
      <i class="ri-"></i>
    </div>
    <div class="text">
      <h4>{{ title }}</h4>
      <p class="p2" [innerHTML]="message"></p>
    </div>
  </div>
</div>
